import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { I18nModule } from "../../i18n/i18n.module";
import { NextButtonComponent } from "./navigation/next-button.component";
import { ScreenHeaderComponent } from "./navigation/screen-header.component";
import { OrderItemDetailsComponent } from "./order-details/order-item-details.component";
import { PickUpComponent } from "./pick-up/pick-up.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { TestHomeComponents } from "./test-home/test-home.component";
import { ItemInfoDisplayComponent } from "./order-details/item-info-display/item-info-display.component";
import { SomethingWrongComponent } from "./errors/something-wrong/something-wrong.component";
import { DropOffComponent } from "./drop-off/drop-off.component";
import { AddItemComponent } from "./add-item/add-item.component";
import { SelectLanguageComponent } from "./language/select-language.component";
import { GlobalErrorComponent } from "./errors/global-error/global-error.component";
import { CustomPipesModule } from "../custom-pipes/custom-pipes.module";

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, I18nModule, CustomPipesModule],
  declarations: [
    NextButtonComponent,
    ScreenHeaderComponent,
    OrderItemDetailsComponent,
    PickUpComponent,
    DropOffComponent,
    NotFoundComponent,
    TestHomeComponents,
    ItemInfoDisplayComponent,
    SomethingWrongComponent,
    AddItemComponent,
    SelectLanguageComponent,
    GlobalErrorComponent,
  ],
  exports: [
    NextButtonComponent,
    ScreenHeaderComponent,
    OrderItemDetailsComponent,
    PickUpComponent,
    DropOffComponent,
    NotFoundComponent,
    TestHomeComponents,
    ItemInfoDisplayComponent,
    SomethingWrongComponent,
    SelectLanguageComponent,
  ],
})
export class SharedComponentModule {}
